/**
 * @generated SignedSource<<2424f736a508adbf70db6929e7b7efc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type manualOrdersTable_ManualOrderFragment$data = {
  readonly createdAt: string;
  readonly discountSelection: ReadonlyArray<{
    readonly code: string;
    readonly createdAt: string;
    readonly id: string;
    readonly numUsages: number;
  }>;
  readonly id: string;
  readonly invoiceNumber: string;
  readonly productSelection: ReadonlyArray<{
    readonly price: {
      readonly grossPrice: any;
      readonly netPrice: any;
      readonly taxRatePercentage: any;
    };
    readonly product: {
      readonly id: string;
      readonly title: string;
    };
  }>;
  readonly salesPerson: {
    readonly name: string;
  };
  readonly " $fragmentType": "manualOrdersTable_ManualOrderFragment";
};
export type manualOrdersTable_ManualOrderFragment$key = {
  readonly " $data"?: manualOrdersTable_ManualOrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"manualOrdersTable_ManualOrderFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "manualOrdersTable_ManualOrderFragment"
};

(node as any).hash = "554d88c3238008112a20a8085e3dc25b";

export default node;
